import React from 'react';
import { DropTarget } from 'react-dnd';

import Box from '../../Box';

const boxTarget = {
  drop(props, monitor) {
    if (monitor.didDrop()) {
      // If you want, you can check whether some nested
      // target already handled drop
      return;
    }
    const item = monitor.getItem();
    if (item.index === undefined) {
      return {
        onBox: true,
      }
    }
  }
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
}

function TargetBox({ connectDropTarget, children }) {
  return connectDropTarget(
    <div style={{ height: '100%' }}>
      {children}
    </div>
  );
}

export default DropTarget('option', boxTarget, collect)(TargetBox);
